<template>
	<Modal @close="$emit('close')" size="small">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<h3>Edit Job</h3>
				</div>
			</div>
			<Form :job="job" @close="$emit('close')"/>
		</div>
	</Modal>
</template>

<script>
import Modal from './../Modal.vue'
import Form from './Form.vue'

export default {
	components: {
		Modal,
		Form
	},
	props: [
		'job'
	]
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Jobs/Edit.vue